import React from 'react';
import Grid from '@material-ui/core/Grid';
//import {Styles} from './Styles';
import {Play} from './Inc';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTint, faWineBottle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


interface Props {
    play:Play,
}

const Parameter = (props:Props)=> {
    //const classes = Styles.base();
    library.add(faTint,faWineBottle);

    return (
        <div id="parameter" style={{marginTop:"0.5em"}}>
        <Grid container spacing={2} id="parameter">
            <Grid item xs={3} style={{position:"relative"}}>
                <p style={{padding:"0",margin:"0",position:"absolute",color:"navy"}}><FontAwesomeIcon icon="tint"/></p>
                <p style={{padding:"0",margin:"0",textAlign:"right"}}>{props.play.water}</p>
            </Grid>
            <Grid item xs={3} style={{position:"relative"}}>
                <p style={{padding:"0",margin:"0",position:"absolute",color:"cyan"}}><FontAwesomeIcon icon="wine-bottle"/>C</p>
                <p style={{padding:"0",margin:"0",textAlign:"right"}}>{props.play.cyan}</p>
            </Grid>
            <Grid item xs={3} style={{position:"relative"}}>
                <p style={{padding:"0",margin:"0",position:"absolute",color:"magenta"}}><FontAwesomeIcon icon="wine-bottle"/>M</p>
                <p style={{padding:"0",margin:"0",textAlign:"right"}}>{props.play.magenta}</p>
            </Grid>
            <Grid item xs={3} style={{position:"relative"}}>
                <p style={{padding:"0",margin:"0",position:"absolute",color:"yellow"}}><FontAwesomeIcon icon="wine-bottle"/>Y</p>
                <p style={{padding:"0",margin:"0",textAlign:"right"}}>{props.play.yellow}</p>
            </Grid>
        </Grid>
        </div>
    );
}

export default Parameter;
